import { render, staticRenderFns } from "./Game_UserBuyProducts.vue?vue&type=template&id=9e9d21ec&scoped=true&"
import script from "./Game_UserBuyProducts.vue?vue&type=script&lang=js&"
export * from "./Game_UserBuyProducts.vue?vue&type=script&lang=js&"
import style0 from "./Game_UserBuyProducts.vue?vue&type=style&index=0&id=9e9d21ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9d21ec",
  null
  
)

export default component.exports